import QuizBoardLandingHeroSection from "./QuizBoardLandingHeroSection";
import QuizBoardLandingFeaturesSection from "./QuizBoardLandingFeaturesSection";
import QuizBoardLandingHowWork from "./QuizBoardLandingHowWork";
import QuizBoardLandingFAQSection from "./QuizBoardLandingFAQSection";
import QuizBoardLandingPageFooter from "./QuizBoardLandingPageFooter";
import QuizCodeBetterSecton from "./QuizCodeBetterSection";
import QuizBoardDailyQuiz from "./QuizBoardDailyQuiz";
import QuizBoardTiles from "./QuizBoardTiles";
// import image from "../../../../assets/images/study.jpg";

const QuizStudioLandingPage =()=>{
  return(
    <>
      <div className="row mx-0">
        <div className="col-12 px-0 main-body">
          <QuizBoardLandingHeroSection />
          <QuizBoardDailyQuiz/>
          <QuizBoardTiles/>
          <QuizCodeBetterSecton/>
          <QuizBoardLandingFeaturesSection />
          <QuizBoardLandingHowWork />
          <QuizBoardLandingFAQSection />
          <QuizBoardLandingPageFooter />
        </div>
      </div>
    </>
  )
}

export default QuizStudioLandingPage;